<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre_3" id="filepos17704"><span class="calibre7"><a class="calibre8"></a><span class="italic1">Why Lazarus Laughed</span></span></h1>
<p class="calibre_4"><span class="calibre4"><em class="italic">The Essential Doctrine,<br class="calibre1"/>Zen - Advaita - Tantra</em></span></p><div class="calibre_1"> </div>
<p class="calibre_5"><span class="calibre5"><img alt="image" class="calibre3" src="images/00002.jpg"/></span></p><div class="calibre_1"> </div>
<p class="calibre_2"><span class="calibre9">WEI WU WEI</span></p>
<p class="calibre_4"><span class="calibre5"><span class="bold"><img alt="image" class="calibre3" src="images/00003.jpg"/></span></span></p>
<p class="calibre_5"><span class="calibre5"><span class="bold">SENTIENT PUBLICATIONS, LLC</span></span></p> <div class="mbp_pagebreak" id="calibre_pb_4"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?87a92928